import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
//import { actionCreators } from '../store/WeatherForecasts';
import { actionCreators } from '../store/actions/dataActions';
// Import React Table
import ReactTable from "react-table";
import "react-table/react-table.css";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import Shortlist from './shortlist';
import ListShortlists from './ListShortLists';
import ShortListFromISRC from './ShortListFromISRC';
import "react-table/react-table.css";
import Select from 'react-select';
import ReadyShortlist from './ReadyShortlists';
import { CSVLink } from 'react-csv';
import Editable from "react-x-editable";

class GenericLists extends Component {

    constructor(props) {
        super(props);
        this.state = {
            codes: "",
            isrcs: "",
            selectedOption: null,
        };
     
    }
componentDidMount() {
    // This method is called when the component is first added to the document
   
    this.ensureDataFetched();
   
}

componentDidUpdate() {
    // This method is called when the route parameters change
    //this.ensureDataFetched();
}

ensureDataFetched() {
    const startDateIndex = parseInt(this.props.match.params.startDateIndex, 10) || 0;
    // this.props.requestWeatherForecasts(startDateIndex);
   // this.props.getData();
 
    }


    onUPCChange(e) {
        this.setState({ codes: e.target.value });
    }

    onISRCChange(e) {
        this.setState({ isrcs: e.target.value });
    } 

    selectListType(data) {

        this.setState(
            { selectedOption : data });

    }

    setPropValue(id, name, _prop) {

        this.props.setProductProp(id, _prop, name.newValue);

    }

render() {
    const access = localStorage.getItem("accessToken");
    console.info(this.props.upcData);
    let url = this.props ? this.props.audioURL : '';
    const options = [
        { value: 'blanks', label: 'Blanks/Catalogues' },
        { value: 'isrc', label: 'UPC from ISRC' },
        { value: 'release', label: 'Release State' },
        { value: 'trackListing', label: 'Track List From UPC' },
        { value: 'PublishedProducts', label: 'All Published Products' },
        { value: 'Jazz', label: 'Jazz assets' },
        { value: 'ShortListsInProgress', label: 'Products in Progress' },
        { value: 'ProductsForUpdate', label: 'Products to Update' },
        { value: 'DspValue', label: 'Average DSP Revenue' },
        { value: 'SimilarProducts', label: 'Similar Products' },
        { value: 'Lyricist', label: 'Lyricists from UPC' },
        { value: 'AssetCatalogSummary', label: 'Count of Asset Catalogue per Upc' },
        { value: 'AssetsArtists', label: 'Assets by Artist' },
        { value: 'AssetsCatalog', label: 'Assets by Catalog' },
        { value: 'getAssetsByTitle', label: 'Assets by Title' },
        { value: 'GetAssetsByISRC', label: 'Assets by ISRC' },
        { value: 'GetTagsByISRC', label: 'Tags by ISRC' },
        { value: 'RequestTags', label: 'Request TMT Tags' },
        { value: 'getArtistIdentifiersFromUpcs', label: 'Get Artist Identifiers from UPC' },
        { value: 'LOP', label: 'Get Assets By LOP' },
    ];
    const { selectedOption } = this.state;

    
    

    return (
        <div>              
                <h1>Lists</h1>

                <div className="row">
                <div className="col-sm-6">
                    <input type="text" disabled={this.props.isLoadingUPCList} className="form-control" id="shortlistISRC" placeholder={"UPCS/ISRCS"} onChange={(e) => this.onUPCChange(e)} value={this.state.codes} ></input>
                </div>
                <div className="col-sm-3">
                    <Select
                        isLoading={this.props.isLoadingUPCList}
                        name="form-field-name"
                        value={selectedOption}
                        options={options}
                        multi={false}
                        onChange={(data) => this.selectListType(data)}
                        disabled={this.props.isLoadingUPCList}
                    /></div>
                <div className="col-sm-3">
                    <button disabled={selectedOption !== null && (selectedOption.value === "PublishedProducts" || selectedOption.value === "Jazz" || selectedOption.value === "ShortListsInProgress" || selectedOption.value === "DspValue") ? false : this.state.codes === '' || this.props.isLoadingUPCList || selectedOption === null} onClick={(e) => this.props.getUpcData(this.state.codes, selectedOption.value)}>Search</button></div>
            </div>

            <br />

          
            <br/>
                <div className="row">
                <div className="col-sm-12">
                    {this.props.upcData !== null && this.props.upcData.length > 0 ? <CSVLink separator=";" data={this.props.upcData} filename={selectedOption !== null ? selectedOption.value + "-List-Data.csv" : "List-data.csv"} >Download CSV</CSVLink> : ""}
                    {this.props.upcData !== null && this.props.upcData.length > 0 ? selectedOption !== null && selectedOption.value === "ProductsForUpdate" ? renderReactTableProducts(this.props.upcData, this.props, this) : renderReactTable(this.props.upcData, this.props, this) : ""}
                    </div>
                </div>

            </div>
          
     
            
            
          

        
    );
}
}



function renderReactTable(data, props,main) {

    console.info(main.state.filtered);

    const getColumns = () => {
        return Object.keys(data[0]).map(key => {
            return {
                Header: key,
                accessor: key
            };
        });
    }
    const onRowClick = (state, rowInfo, column, instance) => {
        if (typeof rowInfo !== "undefined") {
            return {
              
                style: {
                    background: props.tempShortList && props.tempShortList.filter(t => t.isrc === rowInfo.original.isrc).length > 0 ? '#00afec' : 'white',
                    color: props.tempShortList && props.tempShortList.filter(t => t.isrc === rowInfo.original.isrc).length > 0 ? 'white' : 'black',
                    
                }
            }
        } else {
            return {
                onClick: (e, handleOriginal) => {
                    if (handleOriginal) {
                        handleOriginal()
                    }
                }
            }
        }
    }
    return (
        <ReactTable
            getTrProps={onRowClick}
            data={data}
            filterable
           
          
            defaultFilterMethod={(filter, row, column) => {
                const id = filter.pivotId || filter.id;                
                if (typeof filter.value === "object") {                    
                    return row[id] !== undefined || row[id] !==  null
                        ? filter.value.indexOf(row[id]) > -1
                        : true;
                } else {
                    return row[id] !== undefined
                        ? String(row[id]).toLowerCase().indexOf(filter.value.toLowerCase()) !== -1
                        : true;
                }
            }}

              
            columns={getColumns()}
            defaultSorted={[
                {
                    id: "name",
                    desc: true
                }
            ]}
            defaultPageSize={50}
            style={{
                height: "600px" // This will force the table body to overflow and scroll, since there is not enough room
            }}
            className="-striped -highlight"
        />)
};

function renderReactTableProducts(data, props, main) {
    const save = (value, row, _propType) => { main.setPropValue(row, value, _propType); }

    //console.info(main.state.filtered);
    const onRowClick = (state, rowInfo, column, instance) => {
        if (typeof rowInfo !== "undefined") {
            return {

                style: {
                    background: rowInfo.original.upc === props.selectedProductForUpdate ? '#00afec' : 'white',
                    color: rowInfo.original.upc === props.selectedProductForUpdate ? 'white' : 'black',

                }
            }
        } else {
            return {
                onClick: (e, handleOriginal) => {
                    if (handleOriginal) {
                        handleOriginal()
                    }
                }
            }
        }
    }
    return (
        <ReactTable
            getTrProps={onRowClick}
            data={data}
            filterable
            filtered={main.state.filtered}
            onFilteredChange={(filtered, column, value) => {
                main.onFilteredChangeCustom(value, column.id || column.accessor);
            }}

            defaultFilterMethod={(filter, row, column) => {
                const id = filter.pivotId || filter.id;
                if (typeof filter.value === "object") {
                    return row[id] !== undefined || row[id] !== null
                        ? filter.value.indexOf(row[id]) > -1
                        : true;
                } else {
                    return row[id] !== undefined
                        ? String(row[id]).toLowerCase().indexOf(filter.value.toLowerCase()) !== -1
                        : true;
                }
            }}


            columns={[
                {
                    columns: [
                        {

                            Header: "UPC",
                            accessor: "upc",                           
                            Cell: row => (
                                <span style={{ cursor: 'pointer' }} onClick={() => props.selectProductForUpdate(row.value)}> {props.upcData && props.upcData.filter(t => t.upc === row.value).length > 0 ? row.value : row.value}</span>
                        )
                        },
                        {
                            Header: "Title",
                            accessor: "name",
                            Cell: c => (<div>

                                <Editable
                                    handleSubmit={(t) => save(t, c.row.upc, "name")}
                                    name="name"
                                    dataType="text"
                                    mode="inline"
                                    title="Change title"
                                    value={c.row.name}
                                    placement="right"
                                    showButtons={true}
                                    disabled={props.selectedProductForUpdate === c.row.upc ? false : true}
                                />
                            </div>)
                        },
                        {
                            Header: "Version",
                            accessor: "release_version",
                            Cell: c => (<div>

                                <Editable
                                    handleSubmit={(t) => save(t, c.row.upc, "release_version")}
                                    name="name"
                                    dataType="text"
                                    mode="inline"
                                    title="Change title"
                                    value={c.row.release_version}
                                    placement="right"
                                    showButtons={true}
                                    disabled={props.selectedProductForUpdate === c.row.upc ? false : true}
                                />
                            </div>)
                        },
                        {
                            Header: "C Line",
                            accessor: "c_line_text",
                            Cell: c => (<div>

                                <Editable
                                    handleSubmit={(t) => save(t, c.row.upc, "c_line_text")}
                                    name="name"
                                    dataType="text"
                                    mode="inline"
                                    title="Change title"
                                    value={c.row.c_line_text}
                                    placement="right"
                                    showButtons={true}
                                    disabled={props.selectedProductForUpdate === c.row.upc ? false : true}
                                />
                            </div>)
                        },
                        {
                            Header: "C Line Year",
                            accessor: "c_line_year",
                            Cell: c => (<div>

                                <Editable
                                    handleSubmit={(t) => save(t, c.row.upc, "c_line_year")}
                                    name="name"
                                    dataType="text"
                                    mode="inline"
                                    title="Change title"
                                    value={c.row.c_line_year}
                                    placement="right"
                                    showButtons={true}
                                    disabled={props.selectedProductForUpdate === c.row.upc ? false : true}
                                />
                            </div>)
                        },
                        {
                            Header: "P Line",
                            accessor: "p_line_text",
                            Cell: c => (<div>

                                <Editable
                                    handleSubmit={(t) => save(t, c.row.upc, "p_line_text")}
                                    name="name"
                                    dataType="text"
                                    mode="inline"
                                    title="Change title"
                                    value={c.row.p_line_text}
                                    placement="right"
                                    showButtons={true}
                                    disabled={props.selectedProductForUpdate === c.row.upc ? false : true}
                                />
                            </div>)
                        },
                        {
                            Header: "P Line Year",
                            accessor: "p_line_year",
                            Cell: c => (<div>

                                <Editable
                                    handleSubmit={(t) => save(t, c.row.upc, "p_line_year")}
                                    name="name"
                                    dataType="text"
                                    mode="inline"
                                    title="Change title"
                                    value={c.row.p_line_year}
                                    placement="right"
                                    showButtons={true}
                                    disabled={props.selectedProductForUpdate === c.row.upc ? false : true}
                                />
                            </div>)
                        },





                    ]
                }
            ]}
            defaultSorted={[
                {
                    id: "name",
                    desc: true
                }
            ]}
            defaultPageSize={20}
            style={{
                  height: "450px" // This will force the table body to overflow and scroll, since there is not enough room
            }}
            className="-striped -highlight"
        />)
};




export default connect(
    state => state.data,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(GenericLists);



// WEBPACK FOOTER //
// ./src/components/Lists.js